import { Controller } from 'stimulus';

export default class extends Controller {
  static values = {
    editUrl: String,
  };

  connect() {
    this.dispatch('connected');
  }

  updateUrl({ detail }) {
    const boardId = detail.boardId;
    const editUrl = new URL(this.editUrlValue, window.location.origin);
    editUrl.searchParams.set('ref_id', boardId);
    this.element.setAttribute('href', editUrl.toString());
  }
}
